import React from "react";
import { useDisclosure } from "../hooks";
import { FileInspectorInline } from "./file-inspector-inline";
import { FileInspectorLabel } from "./file-inspector-label";
import { FileInspectorModal } from "./file-inspector-modal";
import { type FileInspectorProps, fileInspector } from "./shared";

export function FileInspector<T extends { id: string }>({
	variant = "modal",
	...props
}: FileInspectorProps<T>) {
	/** Props */
	const { itemFiles, size } = props;

	/** Hooks */
	const disclosure = useDisclosure();

	/** Classes */
	const classes = fileInspector({ size });

	/** Render */
	return (
		<React.Fragment>
			<div className="v-stack gap-0">
				<FileInspectorLabel
					onClick={disclosure.onOpen}
					className={classes}
					itemsLength={itemFiles.length}
				/>
				{variant === "inline" ? <FileInspectorInline {...props} /> : null}
			</div>
			{disclosure.isOpen && (
				<FileInspectorModal
					{...props}
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
				/>
			)}
		</React.Fragment>
	);
}
